import { setTaskDetailData } from "actions"
import { store } from "common/store"
import { updateTaskDetail } from "tasks/api"

const updateTaskDetailUseCase = (id, detail) => {
    store.dispatch(setTaskDetailData({ detail }))
    return updateTaskDetail(id, detail)
}

export default updateTaskDetailUseCase